import { useState, useEffect } from 'react';
import { getAllCategories } from '../services/test.service.ts';

export const useAssetCategories = (instance, setPendingApiCalls) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        setPendingApiCalls((current) => current.concat(['getAllCategories']));
        const data = await getAllCategories(instance);
        setCategories(data || []);
      } catch (err) {
        setError(err.message || 'Failed to load asset categories');
      } finally {
        setLoading(false);
        setPendingApiCalls((current) => current.filter((item) => item !== 'getAllCategories'));
      }
    };

    loadCategories();
  }, [instance, setPendingApiCalls]);

  return { categories, loading, error };
};